// src/components/User/Home/HomePage/Contact.js
import React from "react";
import { CAL_LINK } from "../../../../config/siteConfig";

export default function ContactSection() {
    return (
        <section
            id="contact"
            className="px-6 md:px-12 lg:px-36 py-10 md:py-14 scroll-mt-14 border-t border-[rgba(0,0,0,0.06)]"
            style={{ backgroundColor: "var(--bg-base)" }}
        >
            <div className="max-w-2xl mx-auto text-center">
                <h2
                    className="text-3xl md:text-4xl lg:text-[2.6rem] font-extrabold tracking-tight mb-4"
                    style={{ color: "var(--text-primary)" }}
                >
                    Still Not Sure What to Fix First?
                </h2>
                <p
                    className="text-lg md:text-xl leading-relaxed mb-6 max-w-[48ch] mx-auto"
                    style={{ color: "var(--text-secondary)" }}
                >
                    Tell me what you're trying to solve. Let's talk.
                </p>

                <div>
                    <a
                        href={CAL_LINK}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center justify-center px-8 py-4 rounded-full text-base font-semibold shadow-md transform transition hover:-translate-y-0.5 hover:shadow-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 hover:no-underline"
                        style={{
                            backgroundColor: "var(--color-primary)",
                            color: "var(--bg-surface)",
                        }}
                    >
                        Book a Conversation
                    </a>
                </div>
            </div>
        </section>
    );
}
